import { useEffect, useState } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useNavigate } from "react-router-dom";
import { IoIosArrowDropleft } from "react-icons/io";
import { useSelector } from "react-redux";

const TermAndCondition = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
   const { termAndConditionData } = useSelector((state) => state.loginInfo);
   console.log('privacyPolicyData', termAndConditionData )

  const fetchTermAndCondition = async () => {
    try {
      setLoading(true);
      const result = await apiHandler({
        url: `${endpoint.BASE_URL_STAGING}public/images/${termAndConditionData}`,
        method: "GET",
        responseType: "text",
      });

      if (result && result.data) {
        setHtmlContent(result.data);
      }
    } catch (err) {
      console.error("Error fetching HTML content:", err);
      setError("Failed to load content.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (termAndConditionData) {
      fetchTermAndCondition();
    }
  }, [termAndConditionData]);

  const onGoToBackPage = () => {
    navigate(-1);
  };

  return (
    <div className="bg-white min-h-screen p-4">
      <button
        className="back-page-btn d-flex justify-content-between mb-4"
        style={{ cursor: "pointer", fontSize: "16px" }}
        onClick={onGoToBackPage}
      >
        <IoIosArrowDropleft style={{ fontSize: "31px" }} /> <span>Back</span>
      </button>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && !error && (
        <div
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          className="prose max-w-none"
        />
      )}
    </div>
  );
};

export default TermAndCondition;
